import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import {
	Button,
	FormControl,
	FormHelperText,
	FormLabel,
	TextField,
	useTheme,
} from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { FolderSelectDialog } from '../FolderSelectDialog';
import FolderIcon from '@mui/icons-material/Folder';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const NoteFolderSelect = () => {
	const { values, setFieldValue } = useFormikContext();

	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const isRelationshipCompany = Boolean(values.relationshipCompany);

	const resolvedClientId = values.client?.clientId ?? getDealClientId(values.deal);
	const { currentData: clientRow } = useGetClientRowQuery(resolvedClientId, {
		skip: isRelationshipCompany || !resolvedClientId,
	});

	const { currentData: dealRow } = useGetDealRowQuery(values.deal?.dealId, {
		skip: isRelationshipCompany || !values.deal?.dealId,
	});

	const notesDriveId = isRelationshipCompany
		? (values.relationshipCompany?.notesDriveId ?? values.relationshipCompany?.driveId)
		: dealRow
			? dealRow?.notesDriveId
			: clientRow?.notesDriveId;


	//It sets selectedFolder to the Notes folder when the dialog opens, and it switches from the client folder to the deal folder when a deal is chosen.
	useEffect(() => {
		if (isRelationshipCompany) {
			if (!values.selectedFolder && notesDriveId) {
				setFieldValue('selectedFolder', notesDriveId);
			}
			return;
		}
		if (
			(!values.selectedFolder && notesDriveId) ||
			(values.selectedFolder === clientRow?.notesDriveId && dealRow?.notesDriveId)
		) {
			setFieldValue('selectedFolder', dealRow?.notesDriveId ?? notesDriveId);
		}
	}, [
		isRelationshipCompany,
		notesDriveId,
		values.selectedFolder,
		dealRow?.notesDriveId,
		clientRow?.notesDriveId,
		setFieldValue,
	]);

	const fieldDisabled = isRelationshipCompany
		? !values.relationshipCompany
		: !(values.deal || values.client);

	return (
		<>
			<FormControl
				fullWidth
				sx={{
					'& .MuiTextField-root': {
						cursor: 'pointer !important',
					},
				}}
			>
				<FormLabel>{'Save under'}</FormLabel>
				<TextField
					disabled={fieldDisabled}
					placeholder={
						isRelationshipCompany
							? 'Select a folder'
							: 'Select a deal or client to view folders'
					}
					value={values.selectedDrive?.name ?? ''}
					{...(!fieldDisabled && { onClick: () => setOpen(true) })}
					slotProps={{
						input: {
							readOnly: true,
							...(values.selectedDrive?.id && {
								startAdornment: (
									<FolderIcon sx={{ color: '#fbce3a', marginRight: '0.25em' }} />
								),
							}),
							endAdornment: <ArrowDropDownIcon sx={{ color: theme.palette.grey }} />,
						},
					}}
					sx={{
						cursor: 'pointer',
						'& input': { cursor: 'pointer' },
					}}
				/>
				{values.folderPath && <FormHelperText>{values.folderPath}</FormHelperText>}
			</FormControl>
			<FolderSelectDialog
				initialItemId={notesDriveId}
				open={open}
				handleClose={() => setOpen(false)}
			/>
		</>
	);
};

export default NoteFolderSelect;
